<template>
  <section>
    <postalcode v-if="showInputPostalCode" :screenParams="screenParams" @tooltip="(keys) => $emit('tooltip', keys)"></postalcode>
    <residence v-else :screenParams="screenParams"></residence>
  </section>
</template>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import PostalCode from '../components/PostalCode'
  import Residence from '../components/Residence'

  export default Vue.component('postal-code-screen', {
    components: {
      'postalcode': PostalCode,
      'residence': Residence
    },
    props: ['screenParams'],
    data () {
      const app = this.$store.state.app
      const partner = this.$store.state.partner
      const hasPostalCode = app.country && (app.country.singlePostalCode || app.country.postalCodePattern)
      return {
        showInputPostalCode: partner.oneInputAddressCountries.includes(app.country.code) || hasPostalCode || false
      }
    },
    watch: {
      'app.country.code' () {
        this.$nextTick(() => {
          this.showInputPostalCode = this.partner.oneInputAddressCountries.includes(this.app.country.code) || this.app.country.singlePostalCode || this.app.country.postalCodePattern || false
        })
      }
    },
    computed: {
      ...mapState(['app', 'partner'])
    }
  })
</script>



// WEBPACK FOOTER //
// src/screens/PersonalPostalCode.vue